import Repository from '../Repository';
import { useToast } from 'vue-toastification';

const resource = '/sale';
const toast = useToast();

export default {
	index(params) {
		return Repository.get(`${resource}`, { params: params });
	}
}